import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Rgba, getHexColorString, getOpacityFromRgba } from '../../../../helpers/helpers';
import { parseSignatureValue } from '../../../helpers';
import FieldWrapper from './FieldWrapper';
import Image from '../../../../components/svg/Image';
import SignatureModal from '../../Editors/SignatureModal';
import { ValueChangedForFieldFunc } from '../../../formeditor-types';

export interface SignatureFieldProps {
  valueUpdated: ValueChangedForFieldFunc;
  id?: string;
  fieldId?: string;
  x?: number;
  y?: number;
  w?: number;
  h?: number;
  foregroundColor?: string;
  backgroundColor?: string | Rgba;
  padding?: number;
  editable?: boolean;
  name?: string;
  value?: string;
  backgroundCropDimensions?: TypeMePlease;
  signingMethod?: number;
  color?: TypeMePlease;
  formId?: string;
  fileUrls?: Record<string, string>;
  sasToken?: TypeMePlease;
  align?: TypeMePlease;
  rowNumber: number;
}

//@ts-ignore - FIX
@connect(
  (state: TypeMePlease) => ({
    pages: state.formeditor.template?.pages,
    sasToken: state.shared.sasToken,
    fileUrls: state.formeditor.fileUrls
  }),
  {}
)
export default class SignatureField extends PureComponent<SignatureFieldProps, TypeMePlease> {
  constructor(props) {
    super(props);

    this.mouseDown = this.mouseDown.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.getFilePath = this.getFilePath.bind(this);

    this.state = {
      modalOpen: false
    };
  }

  getFilePath(fileId: string) {
    if (this.props.fileUrls) {
      return this.props.fileUrls[fileId];
    }
    if (this.props.sasToken) {
      return `${this.props.sasToken.baseUrl}${fileId}${this.props.sasToken.token}`;
    }
    return null;
  }

  mouseDown() {
    this.setState({ modalOpen: true });
  }

  handleModalClose() {
    this.setState({ modalOpen: false });
  }

  render() {
    let signature = null;
    let modal = null;

    if (this.props.value) {
      if (this.props.value.indexOf('{') === 0) {
        // SignatureV2
        const properties = JSON.parse(this.props.value);
        const signatureUrl = this.getFilePath(properties.FileId);
        if (signatureUrl) {
          signature = <Image src={signatureUrl} align={this.props.align} padding={this.props.padding} w={this.props.w} h={this.props.h} shouldUpscale={true} />;
        }
      } else {
        signature = getSignatureLines(this.props.value, this.props.foregroundColor, this.props.padding || 0);
      }
    }

    if (this.state.modalOpen) {
      let paddedW = this.props.backgroundCropDimensions ? this.props.backgroundCropDimensions.w : this.props.w;
      let paddedH = this.props.backgroundCropDimensions ? this.props.backgroundCropDimensions.h : this.props.h;
      if (this.props.padding) {
        paddedW -= this.props.padding * 2;
        paddedH -= this.props.padding * 2;
      }
      modal = (
        <SignatureModal
          w={paddedW}
          h={paddedH}
          foregroundColor={this.props.foregroundColor}
          name={this.props.name}
          value={this.props.value}
          valueUpdated={this.props.valueUpdated}
          onClose={this.handleModalClose}
          backgroundCropDimensions={this.props.backgroundCropDimensions}
          formId={this.props.formId}
          fieldId={this.props.fieldId}
          signingMethod={this.props.signingMethod}
          color={this.props.color}
          rowNumber={this.props.rowNumber}
        />
      );
    }
    return (
      <FieldWrapper
        onMouseDown={this.mouseDown}
        x={this.props.x}
        y={this.props.y}
        w={this.props.w}
        h={this.props.h}
        backgroundColor={this.props.backgroundColor as Rgba}
        editable={this.props.editable}
        id={this.props.id}
        fieldId={this.props.fieldId}
      >
        {signature}
        {modal}
      </FieldWrapper>
    );
  }
}

export function getSignatureLines(value, foregroundColor, padding) {
  const signatureValue = parseSignatureValue(value);

  const lines = [];
  for (let i = 0; i < signatureValue.length; i++) {
    const coordLine = signatureValue[i];
    const x1 = coordLine.x1 + padding;
    const y1 = coordLine.y1 + padding;
    const x2 = coordLine.x2 + padding;
    const y2 = coordLine.y2 + padding;

    lines.push(
      <line key={`line${i}`} x1={x1} y1={y1} x2={x2} y2={y2} stroke={getHexColorString(foregroundColor)} strokeOpacity={getOpacityFromRgba(foregroundColor)} />
    );
  }
  return lines;
}
